export default __webpack_public_path__ + "static/media/nhacnen.2da9d497.mp3";